export default class NhtNews {
  dom: {
    root: HTMLElement;
    filters: NodeListOf<HTMLSelectElement>;
  };

  constructor(el: HTMLElement) {
    this.dom = {
      root: el,
      filters: el.querySelectorAll('[data-nht-news-filter]'),
    };

    // All neccessary elements found, init functionality
    if(Object.keys(this.dom).every(key => this.dom[key])) {
      console.log('nht-news.init()');
      this.init();
    }
  }

  init() {
    // Hide submit button because filters submit on change
    this.dom.root.querySelectorAll('button[type="submit"]').forEach(submit => {
      submit.classList.add('hidden');
    });

    this.dom.filters.forEach(filter => {
      filter.addEventListener('change', this.onFilterChange.bind(this));
    });
  }

  onFilterChange(e: Event) {
    const target = e.target as HTMLSelectElement;

    if(target.form) {

      if(target.form.classList.contains('loading')) {
        return;
      }

      // Set loading state. Cannot disable fields, since disabled fields are not submitted
      target.form.classList.add('loading');

      target.form.submit();
    }
  }
}
